import React, { useEffect } from 'react';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import Chatbot from './views/ChatbotPage/Chatbot';
import Index from './views/Index';
import Auth from '../hoc/auth';
import LoginPage from './views/LoginSection/LoginPage';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Auth authentication={false} />}>
            <Route exact path="/chatbot" element={<Chatbot />} />
          </Route>
          <Route exact path="/" element={<Index />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route exact path="/login" element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
